<template>
  <div class="chatItem">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt="系统头像" />
    </div>
    <div class="chatWrap">
      <div class="nickname">{{ chatItem.nickname || $i18n('anonymousUser', '匿名用户') }}</div>
      <div class="loginMsg">
        <span class="loginTag">{{ $i18n('checkIn', '签到') }}</span>
        <span class="welcomeIcon">👋</span>
        {{ chatItem.chatContext || $i18n('welcomeToApp', '欢迎登录小程序！') }}
        <span class="sparkle">✨</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import i18nMixin from "@/libs/i18nMixin";
export default {
  name: "ChatLogin",
  mixins: [i18nMixin],
  props: {
    chatItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultAvatar: defaultAvatar
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  animation: fadeIn 0.5s ease;

  .userInfo {
    margin-left: 25px;
    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 2px solid #07C160;
    }
  }

  .chatWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 6px;

    .nickname {
      color: #07C160;
      font-size: 12px;
      margin-bottom: 3px;
      background-color: rgba(7, 193, 96, 0.1);
      padding: 3px 6px;
      border-radius: 3px;
      font-weight: bold;
    }

    .loginMsg {
      font-size: 13px;
      font-weight: 500;
      line-height: 17px;
      color: #333;
      overflow-wrap: break-word;
      background: linear-gradient(to right, #f6ffed, #e6ffdb);
      padding: 8px 12px;
      border-radius: 7px;
      max-width: 280px;
      position: relative;
      border: 1px solid #b7eb8f;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .loginTag {
        display: inline-block;
        background-color: #07C160;
        color: white;
        font-size: 10px;
        padding: 1px 4px;
        border-radius: 3px;
        margin-right: 5px;
        transform: translateY(-1px);
      }

      .welcomeIcon {
        margin-right: 5px;
      }

      .sparkle {
        margin-left: 5px;
      }

      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 5px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-right-color: #e6ffdb;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>